/**
 * Earth Constants
 * Physical and rendering constants for Earth visualization
 */

// Rendering defaults
export const DEFAULT_SPHERE_SEGMENTS = 256
